import api from './index'

const resource = 'survey_answers_reports'

export default {
  getReport (id) {
    return api.get(`${resource}/${id}/download`, { responseType: 'arraybuffer' })
  }
}
